import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { TranslocoLocaleService } from "@jsverse/transloco-locale";
import { Observable } from "rxjs";

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
    private readonly localeService = inject(TranslocoLocaleService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const request = req.clone({
            setHeaders: {
                'Accept-Language': this.localeService.getLocale()
            }
        });

        return next.handle(request);
    }
}
